import '../css/main.scss';

function main() {

  let body = document.querySelector('.page');
  let isModalActive = false;
  let isGameActive = false;
  const menuContainer = document.querySelector('.game__menu');
  const gameContainer = document.querySelector('.game__container');
  let hasFlippedCard = false;
  let lockBoard = false;
  let firstCard, secondCard;

  menuContainer.addEventListener('click', menuEvent);

  function menuEvent(e) {
    const size = e.target.dataset.type;
    if (size === '3x4' || size === '4x5') showGame(+size[0] * +size[2]);
  }

  function showMenu() {
    if (isModalActive) hideModal();
    if (isGameActive) hideGame();
    menuContainer.style.display = 'block';
  }

  function hideMenu() {
    menuContainer.style.display = 'none';

    // Removing all children from an element
    while (gameContainer.firstChild) {
      gameContainer.removeChild(gameContainer.firstChild);
    }
  }

  function showGame(size) {
    hideMenu();
    gameContainer.style.display = 'flex';
    document.querySelector('.header__h1').classList.add('in-game');
    isGameActive = true;

    const cards = [];
    let count = 0;

    while(size--) {
      const card = document.createElement('div');
      cards.push(card);
      card.classList.add('game__card');
      card.classList.add(`game__card--${size}`);
      card.dataset.unraveled = false;
      card.addEventListener('click', flipCard);

      if (size % 2) count++;
      card.dataset.id = `${count}`;

      const frontFace = document.createElement('div');
      const backFace = document.createElement('div');

      frontFace.classList.add('front-face');
      backFace.classList.add('back-face');

      card.append(frontFace, backFace);

      gameContainer.appendChild(card);
    }
    (function shuffle() {
      cards.forEach(card => {
        let ramdomPos = Math.floor(Math.random() * 12);
        card.style.order = ramdomPos;
      });
    })();
  }

  function flipCard() {
    if (this === firstCard) return;
    if (lockBoard) return;

    if (hasFlippedCard) {
      secondCard = this;

      checkForMatch();
    } else {
      firstCard = this;
      hasFlippedCard = true;
    }
    this.classList.toggle('flip');
  }

  function unflipCards() {
    lockBoard = true;
    setTimeout(function() {
      [firstCard, secondCard].forEach(node => {
        node.classList.remove('flip');
      });
      resetBoard();
    }, 500);
  }

  function checkForMatch() {
    if (firstCard.dataset.id === secondCard.dataset.id) match();
    else unflipCards();
  }

  function match() {
    [firstCard, secondCard].forEach(node => {
      node.removeEventListener('click', flipCard);
      node.dataset.unraveled = true;
    });
    resetBoard();
    checkForWin();
  }

  function resetBoard() {
    hasFlippedCard = false;
    lockBoard = false;
    firstCard = null;
    secondCard = null;
  }

  function checkForWin() {
    if (document.querySelectorAll('.game__card[data-unraveled="false"]').length === 0) win();
  }

  function win() {
    showModal();
  }

  function showModal() {
    const modalWrapper = document.createElement('div');
    const modal = document.createElement('div');
    modal.classList.add('modal__content');
    modalWrapper.classList.add('modal');
    modal.textContent = 'Congratulation!!!';
    modal.addEventListener('click', showMenu);

    modalWrapper.appendChild(modal);
    document.body.appendChild(modalWrapper);
    body.classList.add('freeze');
    isModalActive = true;
  }

  function hideModal() {
    document.querySelector('.modal').remove();
    isModalActive = false;
    body.classList.remove('freeze');
  }

  function hideGame() {
    gameContainer.style.display = 'none';
    document.querySelector('.header__h1').classList.remove('in-game');
  }

  document.querySelector('.header__h1').addEventListener('click', showMenu);
  showMenu();
}

window.addEventListener('load', main);

if (module.hot) {
  module.hot.accept();
}
